/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winterocccoolingtemperaturesetpoint4Inputs */



/**
* | output |
* | --- |
* | "Winter occupied cooling setpoint" |
*
* @param {Ahu_History_Key_Winterocccoolingtemperaturesetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winterocccoolingtemperaturesetpoint4 = /** @type {((inputs?: Ahu_History_Key_Winterocccoolingtemperaturesetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winterocccoolingtemperaturesetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter occupied cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid occupation hiver")
});
export { ahu_history_key_winterocccoolingtemperaturesetpoint4 as "ahu_history_key_winterOccCoolingTemperatureSetpoint" }